import { getInjector } from '../../utils/getInjector';
import { getTrackItem } from './utils';
import slEventBus, { eventMetaMap } from '../../../../utils/slEventBus';

/**
 * @param {object} payload
 * @param {string} payload.itemId - The ID of the item to be updated.
 * @param {object} payload.currentCartData - The cart data after update
 * @param {object} [payload.trackerOptions] - The options for tracking (optional)
 * @param {object} payload.cartData - The cart data after quantity update
 */
export const onTrackUpdateItem = async (payload) => {
  const { itemId, currentCartData, trackerOptions = {}, cartData } = payload;
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');
  const cartService = injector.get('cartService');

  // No flattening needed: One Page Store currently have no addon_items.
  const updatedItem = currentCartData.items.find((item) => item.id === itemId);
  const trackItem = getTrackItem(
    updatedItem.product_id,
    updatedItem.variation_id,
    updatedItem.type,
    currentCartData.items,
  );

  // shoplytics
  cartService.tracking(trackerService.userActionTypes.UPDATE_ITEM, trackItem, {
    scope: 'one_page_store',
    eventCategoryEmpty: true,
    ...trackerOptions,
  });

  // for storefront sdk
  slEventBus.emit(eventMetaMap.cart.itemUpdated.name, cartData);
};
